import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function ClockIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M6.92687 4.39877C7.33288 3.99276 7.35259 3.32847 6.84301 3.12963C6.53446 3.00924 6.20169 2.95225 5.86371 2.96193C5.52572 2.97161 5.18914 3.04777 4.87318 3.18605C4.55721 3.32434 4.26806 3.52204 4.02222 3.76788C3.77639 4.01372 3.57868 4.30287 3.4404 4.61883C3.30211 4.9348 3.22595 5.27138 3.21627 5.60936C3.20659 5.94735 3.26358 6.28012 3.38398 6.58867C3.58282 7.09825 4.2471 7.07853 4.65311 6.67253L6.92687 4.39877Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 22C16.9706 22 21.0001 17.9706 21.0001 13C21.0001 8.02944 16.9706 4 12.0001 4C7.0295 4 3.00006 8.02944 3.00006 13C3.00006 17.9706 7.0295 22 12.0001 22ZM12.7501 8C12.7501 7.58579 12.4143 7.25 12.0001 7.25C11.5858 7.25 11.2501 7.58579 11.2501 8V14C11.2501 14.4142 11.5858 14.75 12.0001 14.75H16.0001C16.4143 14.75 16.7501 14.4142 16.7501 14C16.7501 13.5858 16.4143 13.25 16.0001 13.25H12.7501V8Z"
        fill="currentColor"
      />
      <path
        d="M17.1614 3.12963C16.6519 3.32847 16.6716 3.99276 17.0776 4.39877L19.3513 6.67253C19.7574 7.07853 20.4216 7.09825 20.6205 6.58867C20.7409 6.28012 20.7979 5.94735 20.7882 5.60936C20.7785 5.27138 20.7023 4.9348 20.5641 4.61883C20.4258 4.30287 20.2281 4.01372 19.9822 3.76788C19.7364 3.52204 19.4472 3.32434 19.1313 3.18605C18.8153 3.04777 18.4787 2.97161 18.1407 2.96193C17.8028 2.95225 17.47 3.00924 17.1614 3.12963Z"
        fill="currentColor"
      />
    </svg>
  )
}
